import React from "react";

function Privacy() {
  return (
    <div className="container">
      <div className="row">
        <div className="poppins-black mt-3">Privacy Policy</div>
        <p className="poppins-regular mt-2">
          Welcome to www.ProLeverage.io, owned by ProLeverage Pvt Ltd. At
          ProLeverage.io, we prioritize the security and confidentiality of your
          personal data. This Privacy Policy outlines how we collect and process
          your information. By using our website, you acknowledge and consent to
          the practices described in this policy. Please take a moment to read
          and understand this Privacy Policy.
        </p>

        <div className="poppins-medium">
          1. Personal Information We Collect:
        </div>
        <ul>
          <li className="poppins-regular">
            When you visit proleverage.io, we automatically collect certain
            information about your device. This information includes details
            about your web browser, IP address, time zone, and some of the
            cookies installed on your device.
          </li>
          <li className="poppins-regular pt-2">
            Additionally, as you browse our website, we collect information
            about the specific web pages or products you view, the websites or
            search terms that led you to our site, and your interactions with
            the site. We refer to this automatically-collected information as
            “Device Information.”
          </li>
          <li className="poppins-regular pt-2">
            We may also collect personal data you provide to us, such as your
            name, surname, address, payment information, and more, during the
            registration process to fulfill our agreement with you.
          </li>
        </ul>

        <div className="poppins-medium pt-2">2. Why We Process Your Data:</div>
        <div className="poppins-regular">
          Our primary concern is the security of customer data. Therefore, we
          process only the minimal amount of user data necessary to maintain our
          website. Automatically-collected information is used to identify
          potential cases of abuse and to gather statistical information about
          website usage, which is not aggregated in a way that identifies
          individual users. You can visit our website anonymously without
          disclosing any personally identifiable information. However, if you
          wish to use certain features, subscribe to our newsletter, or provide
          information through forms, you may need to provide personal data, such
          as your email, first name, last name, city of residence, organization,
          or telephone number. Failure to provide this information may limit
          your access to certain features of the website.​
        </div>

        <div className="poppins-medium pt-2">3.Your Rights:</div>
        <div className="poppins-regular">
          If you are a European resident, you have certain rights regarding your
          personal data:
        </div>
        <ul>
          <li className="poppins-regular pt-2">The right to be informed.</li>
          <li className="poppins-regular pt-2">The right of access.</li>
          <li className="poppins-regular pt-2">The right to rectification.</li>
          <li className="poppins-regular pt-2">The right to erasure.</li>
          <li className="poppins-regular pt-2">
            The right to restrict processing.
          </li>
          <li className="poppins-regular pt-2">
            The right to data portability.
          </li>
          <li className="poppins-regular pt-2">The right to object.</li>
          <li className="poppins-regular pt-2">
            Rights in relation to automated decision-making and profiling.
          </li>
        </ul>
        <div className="poppins-regular">
          To exercise these rights, please contact us through the contact
          information provided below.
        </div>
        <div className="poppins-regular">
          Please note that we may process your information to fulfill contracts
          with you or pursue legitimate business interests. Your data may be
          transferred outside of Europe, including to Canada and the United
          States.
        </div>

        <div className="poppins-medium pt-2">4. Links to Other Websites:</div>
        <div className="poppins-regular">
          Our website may contain links to external websites not owned or
          controlled by us. We are not responsible for the privacy practices of
          these websites or third parties. When you leave our website, we
          encourage you to read the privacy statements of each website that
          collects personal information.
        </div>

        <div className="poppins-medium pt-2">5. Information Security:</div>
        <div className="poppins-regular">
          We take security seriously. We store your information on secure
          computer servers in a controlled environment to protect it from
          unauthorized access, use, or disclosure. We maintain administrative,
          technical, and physical safeguards to protect against unauthorized
          access, use, modification, and data disclosure. However, we cannot
          guarantee the security of data transmission over the Internet or
          wireless networks.
        </div>

        <div className="poppins-medium pt-2">6. Legal Disclosure:</div>
        <div className="poppins-regular">
          We will disclose collected information when required or permitted by
          law, such as in response to a subpoena or similar legal process, or
          when we believe in good faith that disclosure is necessary to protect
          our rights, your safety, or the safety of others, to investigate
          fraud, or to respond to a government request.
        </div>

        <div className="poppins-medium pt-2">7. Contact Information:</div>
        <div className="poppins-regular">
          If you have questions about this Privacy Policy or need to contact us
          regarding your personal information or individual rights, please email
          us at support@proleverage.io
        </div>
        <div className="poppins-regular">
          Thank you for using proleverage.io and our Mobile App. Your privacy
          and data security are important to us.
        </div>
      </div>
    </div>
  );
}
export default Privacy;
